import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'locale-mixin',
})
export default class LocaleMixin extends Vue {
  get locale(): string {
    if (this.$language.current) {
      return this.$language.current.startsWith('de_') || this.$language.current.endsWith('_DE')
        ? 'de'
        : this.$language.current.replace('_', '-')
    }

    return 'en-US'
  }

  toCurrency(value: number | string, options: Intl.NumberFormatOptions = {}): string {
    if (typeof value === 'string') {
      value = Number.parseFloat(value)
    } else if (value === null || value === undefined) {
      return '-'
    }

    return value.toLocaleString(this.locale, { currency: 'EUR', style: 'currency', ...options })
  }

  toPercent(value: number | string): string {
    return `${value} %`
  }

  toCoins(value: number, factor: number): string {
    const coins = value * factor

    return coins.toLocaleString(this.locale, { useGrouping: true, maximumFractionDigits: 0 })
  }

  centsToCurrency(value: number | string, options: Intl.NumberFormatOptions = {}): string {
    if (typeof value === 'string') {
      value = Number.parseFloat(value)
    }

    return this.toCurrency(value / 100, options)
  }

  toLocalisedDecimal(value: number | string, options: Intl.NumberFormatOptions = {}): string {
    if (typeof value === 'string') {
      value = Number.parseFloat(value)
    }

    return value.toLocaleString(this.locale, {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      ...options,
    })
  }

  toLocalisedInteger(value: number | string): string {
    if (typeof value === 'string') {
      value = Number.parseFloat(value)
    }

    value = Math.round(value)

    return value.toLocaleString(this.locale)
  }

  formatBoolean(value: boolean): string {
    return value ? this.$gettext('Yes') : this.$gettext('No')
  }

  // Get localised date
  // Don't blindly throw this function into Bootstraps formatter BvTableFormatterCallback,
  // as the second parameter does not align with dateFormat
  formatDate(date: string | Date, dateFormat: string = 'LLL'): string {
    if (!date) {
      return '-'
    }
    return this.$moment(date).format(dateFormat)
  }

  formatDateWithoutTime(date: string | Date): string {
    return this.formatDate(date, 'LL')
  }

  getMonthName(monthNumber: number): string {
    return this.$moment().month(monthNumber).format('MMMM')
  }

  getCurrencySymbol(): string {
    return '€' // TODO figure out how to handle different currencies @future-people suck it
  }
}
